import { render, staticRenderFns } from "./cp22New.vue?vue&type=template&id=0d72cd27"
import script from "./cp22New.vue?vue&type=script&lang=js"
export * from "./cp22New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports